"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/xs/xs.module.ts');
const identify_interface_1 = require("./interfaces/identify.interface");
/*

  Short version: All Xs stuff is a rewrite and cleanup of old stuff worth keeping

  At the core of it all sits two properties;
  __ID     = All things identity; classes gets thir own UUID, and id's are create, some introspection
  __EVENTS = All things event participation; subscription, firing, hooks, cleanup, etc.

*/
class XsModule {
    constructor() {
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
    }
}
exports.XsModule = XsModule;
